import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const HaemAgent = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Haemostatic Agent Used</InputLabel>
      <Select
        value={moduleValues?.['Haemostatic Agent Used'] ?? ''}
        label="Haemostatic Agent Used"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Haemostatic Agent Used']: e.target.value,
          }))
        }
      >
        {['Yes', 'No'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default HaemAgent
